export const dropdownPopupMotion = {
	initial: 'closed',
	variants: {
		closed: {
			opacity: 0,
			transitionEnd: {
				display: 'none',
			},
		},
		opened: {
			opacity: 1,
			display: 'block',
		},
	},
	transition: {
		duration: 0.25,
	},
};

export const dropdownContentMotion = {
	variants: {
		closed: {
			y: -20,
			opacity: 0,
		},
		opened: {
			y: 0,
			opacity: 1,
		},
	},
	transition: {
		type: 'spring',
		duration: 0.5,
	},
};
